<script>
import SubHeader from "@/components/SubHeader";
export default {
  components: {
    SubHeader,
  },
  data: () => ({
    headerProps: {
      title: "Gerenciar Descontos",
      btns: [
        {
          text: "Novo",
          color: "primary",
          action: () => {},
          icon: "mdi-plus",
          path: "/preco/descontos/new",
          isRedirector: true,
        },
        {
          text: "Recarregar",
          color: "primary",
          action: () => {},
          icon: "mdi-update",
          path: "",
          isRedirector: false,
        },
      ],
    },
    dialog: false,
    headers: [
      { text: "Trechos", value: "trechos", sortable: false },
      {
        text: "Tipo de Desconto",
        value: "dados.tipo_desconto",
        sortable: false,
      },
      { text: "Tipo Venda", value: "dados.descricao", sortable: false },
      { text: "Data Inicial", value: "dados.data_inicial", sortable: false },
      { text: "Data Final", value: "dados.data_final", sortable: false },
      { text: "Valor R$", value: "dados.valor", sortable: false },
      { text: "Ações", align: "right", value: "action", sortable: false },
    ],
    items: [],
    search: "",
  }),
  created() {
    this.initialize();
    this.headerProps.btns[1].action = () => this.initialize();
  },
  methods: {
    handleSearch: function (value) {
      this.search = value;
    },
    initialize() {
      this.items = [];
      this.$store.dispatch("activeLoader", true);
      this.$http.get("/descontos").then((r) => {
        this.items = r.data;
        this.$store.dispatch("activeLoader", false);
      });
    },
    convertDate(date) {
      return date.split("-").reverse().join("/");
    },
    editar(id) {
      this.$router.push(`/preco/descontos/editar/${id}`);
    },
    deleteItem(id) {
      let c = confirm("Deseja apagar o registro?");
      if (c) {
        this.$store.dispatch("activeLoader", true);
        this.$http.post(`/descontos/delete/${id}`).then((r) => {
          this.$store.dispatch("activeLoader", false);
          alert(r.data.success);
          this.initialize();
        });
      }
    },
  },
};
</script>
